import {XMarkIcon} from "@heroicons/react/24/solid";
import React, {useState} from "react";


const DeletePostContentLine = ({contentLineIndex, handleRemoveContentLine, showIcon}) => {
    const [showConfirm, setShowConfirm] = useState(false);
    const handleConfirm = () => {
        handleRemoveContentLine(contentLineIndex);
        setShowConfirm(false);
    }

    return (
        <>
            {!showIcon && !showConfirm &&
                <button
                    className={`button-red-outline px-1 py-1 text-sm`}
                    onClick={() => setShowConfirm(true)}>
                    Delete
                </button>
            }

            {showIcon && !showConfirm &&
                <button
                    className={`button-red-outline px-1 py-1 text-sm`}
                    onClick={() => setShowConfirm(true)}>
                    <div className="">
                        <XMarkIcon className="h-5 w-5"/>
                    </div>
                </button>
            }

            {showConfirm &&
                <div className={'flex justify-center items-center'}>
                    <div>
                        <button
                            className={`button-red-outline px-2 py-1 text-sm`}
                            onClick={handleConfirm}>
                            <div>Confirm Delete</div>
                        </button>
                    </div>

                    <div>
                        <button
                            className={`button-gray-outline px-2 py-1 ml-2 text-sm`}
                            onClick={() => setShowConfirm(false)}>
                            Cancel
                        </button>
                    </div>
                </div>
            }
        </>
    )
}

export default DeletePostContentLine
